export default __webpack_public_path__ + "static/media/palm_leaf_shadow.0a4ca903.svg";